module.exports = __webpack_public_path__ + "img/lanhu.e01a6065.png";